/* eslint-disable import/prefer-default-export */
import { isNaN } from 'lodash';

export const parseNumber = (value) => {
  const number = value ? parseInt(value, 10) : null;
  return isNaN(number) ? null : number;
};
